export const PIN_NOT_MATCH_VGS_MESSAGE = 'comparison failed';
